<template>
    <div class="cours-thales-stepper-wrapper">
        <!-- Version normale -->
        <v-stepper v-model="currentStep" alt-labels flat class="cours-thales-stepper d-none d-xl-block">
            <v-stepper-header>
                <template v-for="(item, index) in items" :key="index">
                    <v-divider v-if="index !== 0"></v-divider>
                    <v-stepper-item
                        :title="stepTitles[item.value - 1]"
                        :value="item.value.toString()"
                        :complete="step > item.value"
                    ></v-stepper-item>
                </template>
            </v-stepper-header>
        </v-stepper>

        <!-- Version tablette -->
        <v-stepper v-model="currentStep" alt-labels flat class="cours-thales-stepper cours-thales-stepper--tablet d-none d-lg-block d-xl-none">
            <v-stepper-header>
                <template v-for="(item, index) in items" :key="index">
                    <v-divider v-if="index !== 0"></v-divider>
                    <v-stepper-item
                        :title="stepTitlesIntermediate[item.value - 1]"
                        :value="item.value.toString()"
                        :complete="step > item.value"
                    ></v-stepper-item>
                </template>
            </v-stepper-header>
        </v-stepper>

        <!-- Version mobile -->
        <v-stepper v-model="currentStep" vertical flat class="cours-thales-stepper cours-thales-stepper--mobile d-lg-none">
            <v-stepper-header>
                <template v-for="(item, index) in items" :key="index">
                <v-stepper-item
                    :value="item.value.toString()"
                    :complete="step > item.value"
                ></v-stepper-item>
                <v-divider v-if="index !== items.length - 1"></v-divider>
                </template>
            </v-stepper-header>
        </v-stepper>
    </div>
</template>

<script>
export default {

    props: {
        step: {
        type: String,
        required: true,
        },
    },

    data() {
        return {
            items: Array.from({ length: 5 }).map((_, i) => ({
                value: i + 1,
            })),
            stepTitles: [
                'Coordonnées du responsable',
                "Coordonnées de l'élève",
                'Choix de la préparation',
                'Récapitulatif',
                'Confirmation',
            ],
            stepTitlesIntermediate: [
                'Responsable',
                'Élève',
                'Choix de la préparation',
                'Récapitulatif',
                'Confirmation',
            ],
            currentStep: this.step,
        };
    },

    watch: {
        step(newStep) {
            this.currentStep = newStep;
        },
    },
};

</script>


<style scoped>

.cours-thales-stepper-wrapper {
    font-family: 'Nunito Sans', sans-serif;
}

.cours-thales-stepper :deep(.v-stepper),
.cours-thales-stepper :deep(.v-stepper.v-sheet),
.cours-thales-stepper :deep(.v-stepper-header) {
    box-shadow: none !important;
    overflow: visible;
    background: transparent !important;
}

.cours-thales-stepper :deep(.v-stepper-item) {
    opacity: 1 !important;
    padding: 1rem 0.5rem 0.5rem;
}

.cours-thales-stepper :deep(.v-stepper-item__avatar.v-avatar) {
    width: 40px !important;
    height: 40px !important;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 0.9375rem !important;
    font-weight: 700 !important;
    margin-inline-end: 0;
    margin-bottom: 0.75rem !important;
    position: relative;
    overflow: visible !important;
    transition: background-color 0.2s ease, border-color 0.2s ease;
}

.cours-thales-stepper :deep(.v-stepper-item__title) {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1.35;
    color: #06113a;
    margin-top: 0 !important;
    transition: color 0.2s ease, font-weight 0.2s ease;
}

/* Étapes à venir */
.cours-thales-stepper :deep(.v-stepper-item:not(.v-stepper-item--complete):not(.v-stepper-item--selected) .v-stepper-item__avatar.v-avatar) {
    background: #ffffff !important;
    color: #06113a !important;
    border: 2px solid #868ebb !important;
}

/* Étape active + pulse doré léger */
.cours-thales-stepper :deep(.v-stepper-item--selected .v-stepper-item__avatar.v-avatar) {
    background: #06113a !important;
    color: #ffffff !important;
    border: 2px solid #f2cd78 !important;
    animation: step-pulse 2s ease-out infinite;
}

@keyframes step-pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(242, 205, 120, 0.55);
    }
    70% {
        box-shadow: 0 0 0 14px rgba(242, 205, 120, 0);
    }
    100% {
        box-shadow: 0 0 0 0 rgba(242, 205, 120, 0);
    }
}

.cours-thales-stepper :deep(.v-stepper-item--selected .v-stepper-item__title) {
    color: #06113a !important;
    font-weight: 700 !important;
}

/* Étapes terminées */
.cours-thales-stepper :deep(.v-stepper-item--complete .v-stepper-item__avatar.v-avatar) {
    background: #122054 !important;
    color: #ffffff !important;
    border: 2px solid #122054 !important;
}

.cours-thales-stepper :deep(.v-stepper-item--complete .v-stepper-item__title) {
    color: #06113a !important;
    font-weight: 600 !important;
}

.cours-thales-stepper :deep(.v-stepper-item--complete.v-stepper-item--selected .v-stepper-item__avatar.v-avatar) {
    background: #06113a !important;
    border-color: #f2cd78 !important;
}

/* Connecteurs entre étapes — alignés au centre des cercles (40px) */
.cours-thales-stepper:not(.cours-thales-stepper--mobile) :deep(.v-stepper--alt-labels .v-stepper-header .v-divider) {
    align-self: flex-start;
    opacity: 1 !important;
    border-top-width: 2px !important;
    border-color: #868ebb !important;
    margin: 36px -67px 0 !important;
}

.cours-thales-stepper--tablet :deep(.v-stepper-item__title) {
    font-size: 0.875rem !important;
    max-width: 120px;
}

.cours-thales-stepper--mobile :deep(.v-stepper-header) {
    flex-direction: row;
    justify-content: center;
    gap: 0.25rem;
}

.cours-thales-stepper--mobile :deep(.v-stepper-item) {
    padding: 0.5rem;
    flex: 0 0 auto;
}

.cours-thales-stepper--mobile :deep(.v-stepper-item__avatar.v-avatar) {
    width: 32px !important;
    height: 32px !important;
    font-size: 0.8125rem !important;
}

.cours-thales-stepper--mobile :deep(.v-divider) {
    display: none;
}

</style>
